import React from 'react';
import Carousel from 'react-slick';
import classNames from 'classnames';
import Card from 'components/Card/Card.jsx';

import Button from 'components/CustomButtons/Button.jsx';
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import dg1 from 'assets/img/gallery/IMG_9348.jpg';
import dg2 from 'assets/img/gallery/IMG_9337.jpg';
import dg3 from 'assets/img/gallery/IMG_9341.jpg';
import dg4 from 'assets/img/gallery/IMG_9342.jpg';
import dg5 from 'assets/img/gallery/IMG_9335.jpg';
import dg6 from 'assets/img/gallery/IMG_9350.jpg';
import dg7 from 'assets/img/gallery/IMG_9355.jpg';
import dg8 from 'assets/img/gallery/IMG_9373.jpg';
import dg9 from 'assets/img/gallery/IMG_9375.jpg';
import dg10 from 'assets/img/gallery/IMG_9343.jpg';
const settings = {
  dots: false,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
  autoplay: true,
};

export default class Gallery extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <Card>
        <Carousel {...settings}>
          <div style={{ backgroundColor: 'black' }}>
            <img
              width="600"
              height="400"
              style={imageStyles}
              src={dg1}
              className="slick-image"
            />
          </div>
          <div>
            <img
              width="600"
              height="400"
              style={imageStyles}
              src={dg2}
              className="slick-image"
            />
          </div>
          <div>
            <img
              width="600"
              height="400"
              style={imageStyles}
              src={dg3}
              className="slick-image"
            />
          </div>
          <div>
            <img
              width="600"
              height="400"
              style={imageStyles}
              src={dg4}
              className="slick-image"
            />
          </div>
          <div>
            <img
              width="600"
              height="400"
              style={imageStyles}
              src={dg5}
              className="slick-image"
            />
          </div>
          <div>
            <img
              width="600"
              height="400"
              style={imageStyles}
              src={dg6}
              className="slick-image"
            />
          </div>
          <div>
            <img
              width="600"
              height="400"
              style={imageStyles}
              src={dg7}
              className="slick-image"
            />
          </div>
          <div>
            <img
              width="600"
              height="400"
              style={imageStyles}
              src={dg8}
              className="slick-image"
            />
          </div>
          <div>
            <img
              width="600"
              height="400"
              style={imageStyles}
              src={dg9}
              className="slick-image"
            />
          </div>
          <div>
            <img
              width="600"
              height="400"
              style={imageStyles}
              src={dg10}
              className="slick-image"
            />
          </div>
        </Carousel>
      </Card>
    );
  }
}

// backgroundImage: "url(" + blog6 + ")",

const containerStyles = {
  height: '400px',
  padding: '50px',
  backgroundImage: `url("${dg2}")`,
  backgroundSize: 'cover',
  backgroundPosition: 'top',
};

const imageStyles = {
  objectFit: 'contain',
};



// WEBPACK FOOTER //
// ./src/views/YogaPage/Gallery.jsx